module.exports = __webpack_public_path__ + "img/employee.0e21ae37.svg";